import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0e86dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uf-sub-form-item-title"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "uf-form-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 证件类型 ", -1))
const _hoisted_5 = {
  key: 1,
  class: "uf-form-item"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 证件名称 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_7 = {
  key: 2,
  class: "uf-form-item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 上传证件 ", -1))
const _hoisted_9 = {
  key: 0,
  class: "add-detail-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_uf_upload = _resolveComponent("uf-upload")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!

  return (_openBlock(), _createBlock(_component_uf_form_item, {
    title: _ctx.options.title,
    required: _ctx.options.is_checked == '1'
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "certificate",
          key: item.id
        }, [
          (_ctx.certificates.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createTextVNode(" 资格证" + _toDisplayString(index + 1) + " ", 1),
                (index !== 0 && !_ctx.disabled)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "delete",
                      onClick: ($event: any) => (_ctx.removeCertificate(index))
                    }, " 删除 ", 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_van_field, {
              modelValue: item.certificateTypePicker.label,
              "onUpdate:modelValue": ($event: any) => ((item.certificateTypePicker.label) = $event),
              readonly: "",
              clickable: "",
              placeholder: "请选择",
              "right-icon": "arrow",
              onClick: ($event: any) => (_ctx.fieldClick(item))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
          ]),
          (item.certificateTypePicker.value == '5')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_van_field, {
                  modelValue: item.certificateName,
                  "onUpdate:modelValue": ($event: any) => ((item.certificateName) = $event),
                  placeholder: "请输入",
                  rules: [{ required: true, message: '请填写证件名称' }]
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          (item.certificateTypePicker.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_van_field, null, {
                  input: _withCtx(() => [
                    _createVNode(_component_uf_upload, {
                      modelValue: item.certificateFile,
                      "onUpdate:modelValue": ($event: any) => ((item.certificateFile) = $event),
                      "max-count": "1",
                      "tip-text": "支持扩展名：.png .jpg .pdf，单个文件大小不超过10M",
                      "max-size": 20 * 1024 * 1024
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_van_popup, {
            show: item.certificateTypePicker.showPicker,
            "onUpdate:show": ($event: any) => ((item.certificateTypePicker.showPicker) = $event),
            position: "bottom",
            "lazy-render": false,
            "safe-area-inset-bottom": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                title: "证件类型",
                columns: item.certificateTypePicker.columns,
                onConfirm: item.certificateTypePicker.onConfirm,
                onCancel: item.certificateTypePicker.onCancel,
                onChange: item.certificateTypePicker.onChange
              }, null, 8, ["columns", "onConfirm", "onCancel", "onChange"])
            ]),
            _: 2
          }, 1032, ["show", "onUpdate:show"]),
          (index !== _ctx.certificates.length - 1)
            ? (_openBlock(), _createBlock(_component_van_divider, {
                key: 3,
                style: { margin: '0', padding: '0 15px' }
              }))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (!_ctx.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "add-detail",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addCertificate()))
            }, [
              _createVNode(_component_van_icon, {
                name: "plus",
                style: {"margin-right":"5px"}
              }),
              _createTextVNode(" 新增 ")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "required"]))
}